import {
    Stack,
    PrimaryButton,
    DefaultButton,
    BaseButton,
    Button,
} from '@fluentui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import React, { BaseSyntheticEvent, MouseEvent } from 'react';
import { useForm } from 'react-hook-form';
import { appStyles } from '../../helpers';
import { useAppSelector, useAppDispatch } from '../../store';
import { createFolderThunk } from '../../store/actions/app/thunks';
import { selectTranslate } from '../../store/selectors/ui';
import { ControlledTextField } from './controls/controlledTextField';
import { createFolderFormDataSchema } from '../../schemas/createFolder';
import { CreateFolderData } from '../../model';

type Props = {
    pathForCreation: string;
    onCancel: (
        event?: MouseEvent<HTMLElement | BaseButton | Button> | null,
    ) => void;
};

export const CreateFolderForm = ({ pathForCreation, onCancel }: Props) => {
    const translate = useAppSelector(selectTranslate);
    const { handleSubmit, register, control } = useForm<CreateFolderData>({
        defaultValues: {
            path: pathForCreation,
            folderName: '',
        },
        resolver: zodResolver(createFolderFormDataSchema),
        mode: 'onSubmit',
    });

    const dispatch = useAppDispatch();
    const onSubmitHandler = (
        data: CreateFolderData,
        _e?: BaseSyntheticEvent,
    ) => {
        onCancel(null);
        dispatch(createFolderThunk(data));
    };

    return (
        <form onSubmit={handleSubmit(onSubmitHandler)}>
            <Stack tokens={{ childrenGap: '1rem' }}>
                <ControlledTextField
                    control={control}
                    {...register('folderName')}
                    label={translate('enter_name')}
                />
                <Stack
                    horizontal={true}
                    horizontalAlign="end"
                    tokens={{ childrenGap: '1rem' }}
                >
                    <DefaultButton
                        styles={appStyles.primaryButtonReverse}
                        onClick={onCancel}
                    >
                        {translate('button_cancel')}
                    </DefaultButton>
                    <PrimaryButton
                        type="submit"
                        styles={appStyles.primaryButton}
                    >
                        {translate('button_create')}
                    </PrimaryButton>
                </Stack>
            </Stack>
        </form>
    );
};
